import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormFields } from '../../helpers/FormFields';
import { IdentityService } from '../../services/Identity.Service';
import ActionButton from '../../components/Buttons/ActionButton';
import { getPasswordValidationError, passwordPolicyDescription } from '../../helpers/PasswordPolicy';

export default function Reset() {
  const history = useNavigate();
  const token = new URLSearchParams(window.location.search).get('t');
  const email = new URLSearchParams(window.location.search).get('e');
  const [errorText, setErrorText] = useState<string>('');
  const [buttonText, setButtonText] = useState<string>('Change your Password');
  const [fields, handleFieldChange] = useFormFields({ password: '', confirmed: '' });
  const [successful, setSuccessful] = useState<boolean>(false);

  useEffect(() => {
    if (token === null) {
      history('/Login');
    }
    document.title = 'BraveGen | Reset Password';
  }, [history, token]);

  const greeting = () => {
    var time = new Date().getHours();

    if (time < 12) {
      return 'Good Morning!';
    }
    if (time >= 17) {
      return 'Good Evening!';
    }
    if (time >= 12) {
      return 'Good Afternoon!';
    }
    return '';
  };

  async function handleReset(event: any) {
    event.preventDefault();

    if (buttonText !== 'Processing...') {
      const validationError = getPasswordValidationError(fields.password, fields.confirmed);
      if (validationError) {
        setErrorText(validationError);
        return;
      }

      //Reset and loading state.
      setButtonText('Processing...');
      setErrorText('');

      const result = await IdentityService.resetPassword(email ?? '', fields.password, token ?? '');

      if (result.valid) {
        setButtonText('Updated!');
        setSuccessful(true);
      } else {
        setErrorText(result.errorMessage);
        setButtonText('Change your Password');
      }
    }
  }

  return (
    <div className="box">
      <img src="/resources/Lion-Full.png" className="animate" alt="BraveGen" />
      <div className="inner animate login">
        <h1>{greeting()}</h1>
        {!successful && (
          <>
            <span>
              You can now reset your Hub credentials for <strong>{email}</strong>.
              <br />
              <br />
              {passwordPolicyDescription}
            </span>
            <form onSubmit={handleReset}>
              <div className="group">
                <p>Your new Password:</p>
                <input
                  id="password"
                  className="input"
                  autoFocus
                  type="password"
                  value={fields.password}
                  onChange={handleFieldChange}
                />
              </div>
              <div className="group">
                <p>Confirm Password again:</p>
                <input
                  id="confirmed"
                  className="input"
                  type="password"
                  value={fields.confirmed}
                  onChange={handleFieldChange}
                />
              </div>
              <span className="error">{errorText}</span>
              <p className="forgot">
                <a
                  href="#0"
                  onClick={() => {
                    history('/Login');
                  }}>
                  Remembered your password?
                </a>
              </p>
              <ActionButton
                type="submit"
                className="full-width offset"
                disabled={buttonText === 'Processing...'}
                label={buttonText}></ActionButton>
            </form>
          </>
        )}
        {successful && (
          <>
            <span>
              Congratulations! Your Hub credentials for <strong>{email}</strong> was successfully updated.
              <br />
              <br />
              Lets sign in to test out your new credentials!
            </span>
            <ActionButton
              type="submit"
              className="full-width offset"
              label="Sign In"
              onClick={() => {
                history('/Login');
              }}></ActionButton>
          </>
        )}
      </div>
    </div>
  );
}
